// WAAP Prefetch — one-shot cache warm via the private CDN portal:
//   POST /prefetch  { urls: [...] }  (1-25 URLs)
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { serviceApiV3 } from '@/api/client';
import { waapPath, WAAP_AREAS } from './_shared';

/** Warm the cache with the given URLs (fire-and-forget). */
export function useWaapPrefetch(
  domainId: string,
  options?: UseMutationOptions<unknown, unknown, { urls: string[] }>,
) {
  return useMutation({
    mutationFn: async (body: { urls: string[] }) => {
      const res = await serviceApiV3.post(waapPath(domainId, WAAP_AREAS.prefetch), body);
      return res.data;
    },
    ...options,
  });
}
